import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css'],
  providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }]
})
export class SideMenuComponent {

  activeTab: number = 0;

  constructor(private conn: ConnectionService, private route: Router) { }

  ngOnInit() {
    let url = this.route.url
    if (url == '/pages/account-chart') {
      this.activeTab = 1
    }
    else if (url == '/pages/network-chart') {
      this.activeTab = 0
    }
    else if (url == '/pages/transaction-chart') {
      this.activeTab = 2
    }
    else {
      this.activeTab = 3
    }
  }

  getNetwork() {
    this.route.navigate(['pages/network-chart'])
  }
  getAccounts() {
    this.route.navigate(['pages/account-chart'])
  }
  getTransactions() {
    this.route.navigate(['pages/transaction-chart'])
  }
  getContracts() {
    this.route.navigate(['pages/contract-chart'])
  }
}



